// src/features/projects/components/ProjectContentSections.tsx

import React from 'react';
import styles from './ProjectContentSections.module.scss';
import { ContentSection, ImageAlignment } from '../types/project';

interface ProjectContentSectionsProps {
  sections: ContentSection[];
}

const ProjectContentSections: React.FC<ProjectContentSectionsProps> = ({ sections }) => {
  return (
    <section className={styles.contentSections}>
      <div className={styles.sectionsContainer}>
        {sections.map((section, index) => {
          const isLeft = section.imageAlignment === ImageAlignment.Left;
          
          return (
            <article
              key={index}
              className={`${styles.sectionItem} ${isLeft ? styles.leftItem : styles.rightItem}`}
            >
              <div className={styles.contentGrid}>
                {/* Image Side */}
                <div className={styles.imageContainer}>
                  <div className={styles.imageWrapper}>
                    <img 
                      src={section.contentImage} 
                      alt={section.title}
                      className={styles.sectionImage}
                    />
                    <div className={styles.imageGradient}></div>
                  </div>
                </div>

                {/* Content Side */}
                <div className={styles.textContainer}>
                  <div className={styles.textContent}>
                    <div className={styles.sectionMeta}>
                      <span className={styles.sectionLabel}>Phase {(index + 1).toString().padStart(2, '0')}</span>
                    </div>
                    <h3 className={styles.sectionTitle}>{section.title}</h3>
                    <p className={styles.paragraph}>{section.paragraphText}</p>
                  </div>
                </div>
              </div>

              {/* Decorative Elements */}
              <div className={styles.backgroundPattern}></div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default ProjectContentSections;